import { Label } from '@/components/ui/label';
import useLogin from './uesLogin';
import { Input } from '@/components/ui/input';
import Button from '@/components/Button';
import { Link } from 'react-router-dom';
import Container from '@/components/Container';
import FieldError from '@/components/FieldError';
import { Suspense } from 'react';
import Loading from './loading.skeleton';

function LoginComponent() {
  const {
    handleSubmit,
    register,
    loginPage,
    isConfirmation,
    errors,
    isLocked,
    isSubmitting,
    recaptchaEnabled,
    formError,
  } = useLogin();

  const renderHeaderMessages = () => {
    if (isConfirmation) {
      return (
        <>
          <p className=" mb-2 font-haffer text-sh-md font-bold">{loginPage?.confirmEmailTitle}</p>{' '}
          <p className=" mb-8 font-haffer text-sh-sm">{loginPage?.pleaseLoginTItle}</p>
        </>
      );
    }

    return (
      <h2 className="mb-[32px] text-center font-haffer text-sh-30-38 font-bold leading-9 tracking-tight text-black-200">
        {loginPage?.loginTitle}
      </h2>
    );
  };

  return (
    <Container className="h-full">
      <div className="col-span-12 flex min-h-0 items-center justify-center py-4">
        <div className="flex max-h-[90dvh] w-full max-w-[430px] flex-col items-start overflow-auto rounded-2xl bg-white p-8 shadow-lg">
          <img
            className="mb-4 h-auto h-auto w-[100px] self-start"
            src={loginPage?.pageImage.data?.attributes?.url}
            alt={loginPage?.pageImage.data?.attributes?.alternativeText || 'Logo'}
          />
          {renderHeaderMessages()}

          <form className="flex w-full flex-col items-start" onSubmit={handleSubmit}>
            <div className="mb-4 w-full">
              <Label>
                <p className="mb-2 font-haffer text-sh-xs text-dark-grey">{loginPage?.yourEmailTitle}</p>
              </Label>
              <Input placeholder={loginPage?.yourEmailTitle} type="email" {...register('identifier')} />
              {errors?.identifier?.message && <FieldError message={errors?.identifier?.message} />}
            </div>

            <div className="mb-[30px] w-full">
              <Label>
                <p className="mb-2 font-haffer text-sh-xs text-dark-grey">{loginPage?.yourPasswordTitle}</p>
              </Label>
              <Input placeholder={loginPage?.yourPasswordTitle} type="password" {...register('password')} />
              {errors?.password?.message && <FieldError message={errors?.password?.message} />}
              {formError && <FieldError message={formError} />}
            </div>

            <Button
              type="submit"
              theme="solid"
              className="mb-4"
              showChevron={false}
              disabled={isLocked}
              loading={isSubmitting}>
              {loginPage?.loginCta}
            </Button>
          </form>
          <Link
            className="text-center font-haffer text-sh-xs font-bold text-people-teal-600 hover:!text-people-blue-600"
            to="/reset-password">
            {loginPage?.forgotYourPasswordCta}
          </Link>

          <p className="mt-4 font-haffer text-sh-xs font-normal">
            Don&apos;t have a login?{'  '}
            <Link className="text-center font-bold text-people-teal-600 hover:!text-people-blue-600" to="/register">
              Register here
            </Link>
          </p>

          {recaptchaEnabled && (
            <p className="mt-4 font-haffer text-sh-xs font-normal text-dark-grey">
              This site is protected by reCAPTCHA and the Google{' '}
              <a
                className="font-bold text-people-teal-600 hover:!text-people-blue-600"
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer">
                Privacy Policy
              </a>{' '}
              and{' '}
              <a
                className="font-bold text-people-teal-600 hover:!text-people-blue-600"
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer">
                Terms of Service
              </a>{' '}
              apply.
            </p>
          )}
        </div>
      </div>
    </Container>
  );
}

export default function Login() {
  return (
    <Suspense fallback={<Loading />}>
      <LoginComponent />
    </Suspense>
  );
}
